export const showSourceUrl = (url: string) => {
  return !url.includes('app.hubspot.com/tickets/');
};
